import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { Button } from "@/core/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/core/components/ui/popover";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";

export const PushPayExcludedLines = ({ warnings }: { warnings: string[] }) => {
  if (warnings.length === 0) return null;

  const label = `${warnings.length} ${warnings.length === 1 ? "line" : "lines"} not included`;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="text"
          size="xs"
          leftIcon={<InformationCircleIcon className="size-4" />}
          className="h-auto gap-1.5 px-0 py-1 text-secondary-text [&_svg]:!size-4"
        >
          {label}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" sideOffset={8} className="w-[28rem] p-0">
        <Stack gap="xs" className="border-b border-stroke-tertiary px-4 py-3">
          <Typography variant="bodyW2" className="font-medium">
            {label}
          </Typography>
          <Typography variant="captionW1" textColor="secondary">
            PushPay cannot push these lines. Review the reasons below.
          </Typography>
        </Stack>
        <ul className="max-h-64 overflow-y-auto px-4 py-3">
          {warnings.map((warning, index) => (
            <li
              key={`${warning}-${index}`}
              className="border-b border-stroke-tertiary py-2 last:border-b-0"
            >
              <Typography variant="captionW1">{warning}</Typography>
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  );
};
